var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBnbBnbLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1563_5980)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C15.5232 0 20 4.47676 20 10C20 15.5232 15.5232 20 10 20C4.47676 20 0 15.5232 0 10C0 4.47676 4.47676 0 10 0Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49599 9.99992L5.50321 12.6442L7.75 13.9663V15.5143L4.1883 13.4254V9.22669L5.49599 9.99992ZM5.49599 7.35569V8.89656L4.1875 8.12252V6.58166L5.49599 5.80762L6.8109 6.58166L5.49599 7.35569ZM8.6883 6.58166L9.99679 5.80762L11.3117 6.58166L9.99679 7.35569L8.6883 6.58166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44141 12.0961V10.548L7.7499 11.322V12.8629L6.44141 12.0961ZM8.6882 14.5208L9.99669 15.2948L11.3116 14.5208V16.0616L9.99669 16.8357L8.6882 16.0616V14.5208ZM13.1882 6.58166L14.4967 5.80762L15.8116 6.58166V8.12252L14.4967 8.89656V7.35569L13.1882 6.58166ZM14.4967 12.6442L14.5039 9.99993L15.8124 9.22589V13.4246L12.2507 15.5135V13.9655L14.4967 12.6442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5585 12.0959L12.25 12.8628V11.3219L13.5585 10.5479V12.0959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5584 7.90365L13.5656 9.45172L11.3124 10.7738V13.4245L10.0039 14.1913L8.69541 13.4245V10.7738L6.44221 9.45172V7.90365L7.75631 7.12961L9.99589 8.45813L12.2491 7.12961L13.564 7.90365H13.5584ZM6.44141 5.26022L9.99669 3.16406L13.5584 5.26022L12.2499 6.03425L9.99669 4.70573L7.7499 6.03425L6.44141 5.26022Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1563_5980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbBnbLogo);
export default __webpack_public_path__ + "static/media/bnb-bnb-logo.1b8eac029d87165151ad705eed93e0bc.svg";
export { ForwardRef as ReactComponent };